"use client";

import { AppPageTitle } from "@/widgets";
import AccessibleTrail from "@/widgets/app/page/wemap/AccessibleTrail";
import AppDetailSection from "@/widgets/app/page/wemap/AppDetailSection";
import AppMainSection from "@/widgets/app/page/wemap/AppMainSection";
import DownLoadSection from "@/widgets/app/page/wemap/DownLoadSection";
import FirstInfoSection from "@/widgets/app/page/wemap/FirstInfoSection";
import { SsgoiTransition } from "@ssgoi/react";

export default function WemapPage() {
  return (
    <SsgoiTransition id="/app/pages/wemap">
      <div className="max-[991px]:pt-16 flex pt-24 w-full flex-col">
        <AppPageTitle />
      </div>

      <div className="w-full flex-col">
        {/* 설명 타이틀 */}
        <FirstInfoSection />
        {/* 다운로드 */}
        <DownLoadSection />
        {/* 서비스 메인페이지 */}
        <AppMainSection />
        {/* 장소 디테일 화면 */}
        <AppDetailSection />
        {/* 무장애 나눔길 */}
        <AccessibleTrail />
      </div>
    </SsgoiTransition>
  );
}
